import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { MicrodataHTMLAttributes } from '@rover/react-lib/src/components/microdata';

import CalloutBadgeStyle from './CalloutBadge.constants';

type StyledBadgeProps = {
  calloutBadgeStyle?: CalloutBadgeStyle;
};
const Badge = styled.span<StyledBadgeProps>`
  ${({ calloutBadgeStyle = CalloutBadgeStyle.DEFAULT }) => calloutBadgeStyle.toString()};
`;
export type Props = {
  value: ReactNode | string;
  calloutBadgeStyle?: CalloutBadgeStyle;
} & MicrodataHTMLAttributes;

const CalloutBadge = ({ value, ...other }: Props): ReactElement => {
  return <Badge {...other}>{value}</Badge>;
};

CalloutBadge.Styles = CalloutBadgeStyle;
export default CalloutBadge;
